module.exports = __webpack_public_path__ + "img/growththumb.ca5d3940.jpg";